import React, { useState } from 'react';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';

const TermsConditions = () => {
    let ThePara = '"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"';
    const Terms = [
        {
            Name: "Definitions",
            Para: ThePara
        },
        {
            Name: "Responsibilities of webtrans logistics inc",
            Para: ThePara
        },
        {
            Name: "Customers",
            Para: ThePara
        },
        {
            Name: "Unacceptable Goods ",
            Para: ThePara
        },
        {
            Name: "Transportation, Handling and Storage Charges",
            Para: ThePara
        },
        {
            Name: "Limitations On Webtrans’s Liability",
            Para: ThePara
        },
        {
            Name: "Indemnification",
            Para: ThePara
        },
        {
            Name: "Advancing Money",
            Para: ThePara
        },
        {
            Name: "Arbitration",
            Para: ThePara
        },
        {
            Name: "Conditions For Filing Suit Against Webtrans",
            Para: ThePara
        },
        {
            Name: "Modification Of These Terms and Conditions",
            Para: ThePara
        },
        {
            Name: "Severability",
            Para: ThePara
        },
        {
            Name: "Governing Law",
            Para: ThePara
        }
    ];
    return (
        <>
            <Header />
            {/* Terms Conditions Section Start Here */}
            <section className="terms-section pt-3 pt-lg-5 pb-5 mt-3">
                <div className="container">
                    <div className="terms-start">
                        <div className="top-headings">
                            <h2 className="lg-heading text-center mb-4">Terms and Conditions</h2>
                            <p className="lg-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit</p>
                            <ul className="terms-list mt-5">
                                {
                                    Terms.map((term, index) => (
                                        <>
                                            <li className="single-term mb-5" key={index}>
                                                <h6 className="xs-heading"><span className='xs-heading pe-2'>{index+1}.</span>{term.Name}</h6>
                                                <p className='text'>{term.Para}</p>
                                            </li>
                                        </>
                                    ))
                                }

                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            {/* Terms Conditions Section End Here */}
            {/* Footer Included Here */}
            <Footer />
            {/* Footer Included Here */}
        </>
    )
}
export default TermsConditions;